import { useEffect, useRef, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export default function UnconfirmedAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);
  const seenRef = useRef("");

  const load = async () => {
    try {
      const { data } = await api.get("/substitutions/unconfirmed-alerts");
      const list = data.alerts || [];
      setAlerts(list);
      const sig = list.map((a) => a.id).sort().join(",");
      if (list.length === 0) {
        seenRef.current = "";
        setOpen(false);
      } else if (sig !== seenRef.current) {
        seenRef.current = sig;
        setOpen(true);
      }
    } catch (e) {
      // silenzioso: il polling non deve disturbare l'admin
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  const markHandled = async (id) => {
    try {
      await api.post(`/substitutions/${id}/confirm`);
      toast.success("Sostituzione segnata come gestita");
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="unconfirmed-alerts-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" /> Sostituzioni non confermate
          </DialogTitle>
          <DialogDescription>
            I seguenti docenti non hanno confermato la lettura su Telegram entro l'inizio dell'ora:
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-80 overflow-auto">
          {alerts.map((a) => (
            <div
              key={a.id}
              data-testid={`unconfirmed-alert-${a.id}`}
              className="flex items-center justify-between gap-3 rounded-md border border-border p-3"
            >
              <div className="text-sm">
                <p className="font-medium">{a.teacher_name}</p>
                <p className="text-muted-foreground">Classe {a.class_name} · {a.slot_label}</p>
              </div>
              <Button
                size="sm"
                variant="outline"
                data-testid={`mark-handled-${a.id}`}
                onClick={() => markHandled(a.id)}
              >
                Segna gestito
              </Button>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="ghost" data-testid="close-alerts-button" onClick={() => setOpen(false)}>
            Chiudi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
